import { NgModule } from '@angular/core';
import { CommonNavigationModule } from '@capital-access/common/navigation';
import { CommonRouterModule } from '@capital-access/common/router';

export const loadModule = () => import('@capital-access/measure/client').then(m => m.MeasureClientModule);

// @dynamic
@NgModule({
  imports: [
    CommonNavigationModule.forFeature({
      top: [
        {
          localizationKey: 'measure',
          icon: 'f-i-graph',
          order: 300,
          link: 'measure'
        }
      ]
    }),
    CommonRouterModule.forFeature({
      authorized: [
        {
          path: 'measure',
          loadChildren: loadModule
        }
      ]
    })
  ]
})
export class MeasureClientLazyModule {}
